import React, { useEffect, useState } from "react";

export default function OnlineChecker() {
    const [online, setOnline] = useState(true);
    useEffect(() => {
        window.addEventListener("offline", () => setOnline(false));
        window.addEventListener("online", () => setOnline(true));
        return () => {
            window.removeEventListener("offline", () => setOnline(false));
            window.removeEventListener("online", () => setOnline(true));
        };
    }, []);
    if (online) {
        return null;
    }
    return (
        <div className="page-layout__notification-wrap">
            <div className="page-layout__notification page-layout__notification--danger">
                Интернет соединение потеряно
            </div>
        </div>
    );
}
